module.exports = __webpack_public_path__ + "public/images/marsupial.abf61356b6e2ec14d584370ad1226787.png";